import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20warm%20abstract%20illustration%20with%20soft%20coral%20and%20amber%20gradient%20tones%20blending%20into%20cream%20white%2C%20subtle%20comic%20panel%20line%20textures%2C%20Korean%20manhwa%20inspired%20geometric%20shapes%20and%20flowing%20curves%2C%20dreamy%20atmospheric%20background%20with%20gentle%20light%20diffusion%2C%20minimalist%20modern%20digital%20art%20composition%20with%20organic%20flowing%20forms%2C%20clean%20elegant%20aesthetic%2C%20no%20text%20no%20characters%2C%20pure%20artistic%20background%20suitable%20for%20website%20hero&width=1800&height=1200&seq=hero-bg-main-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 pt-20 pb-10 text-center">
        <div className="flex items-center justify-center gap-2 mb-6">
          <span className="text-xs text-white/80 bg-white/10 backdrop-blur-sm px-3 py-1 rounded-full whitespace-nowrap border border-white/20">
            每日更新 · 海量韩漫资源 · 完全免费
          </span>
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-black text-white leading-tight tracking-tight mb-6 drop-shadow-lg">
          韩漫在线
        </h1>

        <p className="text-lg md:text-xl text-white/80 font-heading mb-4">
          好看的韩国漫画大全
        </p>

        <p className="text-sm md:text-base text-white/60 max-w-xl mx-auto leading-relaxed mb-10">
          汇聚全网热门韩国漫画，更新及时、画质高清，为您打造极致的在线阅读体验。无论你喜欢浪漫爱情还是热血冒险，这里都有属于你的故事。
        </p>

        <div className="flex items-center justify-center gap-4 flex-wrap">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-white text-foreground-950 rounded-full text-sm font-medium hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-white/40 text-white rounded-full text-sm font-medium hover:bg-white/10 hover:border-white/60 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-6 pb-8">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20artistic%20illustration%20collage%20featuring%20diverse%20characters%20in%20romance%20action%20fantasy%20drama%20styles%2C%20warm%20cream%20and%20coral%20background%20blending%20seamlessly%2C%20clean%20minimalist%20composition%20with%20soft%20artistic%20brush%20texture%2C%20elegant%20Korean%20digital%20art%20style%2C%20harmonious%20palette%20of%20warm%20earth%20tones%20amber%20and%20soft%20pink%2C%20editorial%20quality%20arrangement%2C%20no%20text%20just%20pure%20art%2C%20sophisticated%20modern%20aesthetic&width=1400&height=700&seq=hero-banner-collage-02&orientation=landscape"
          alt="韩漫在线 - 韩国漫画精选合集"
          title="韩漫在线 - 韩国漫画精选合集"
          className="w-full h-auto rounded-2xl object-cover shadow-2xl"
        />
      </div>
    </section>
  );
}